// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productActionsStyle } from "@steiner/App/Components/Product/ProductActions";
import { hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productActionsStyle.addToCartContainer = {
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
        .has-uom {
            flex-direction: column;
        }

        ${hideElementOnPrint}
    `,
};

productActionsStyle.qtyWrapper = {
    css: css`
        max-width: 100px;
    `,
};

productActionsStyle.addToCartButtonWrapper = {
    css: css`
        min-width: 234px;
        ${xScreen("lte", "md")} {
            flex-grow: 1;
            min-width: initial;
        }
    `,
};

productActionsStyle.addCutLengthsButtonWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

productActionsStyle.productUomWrapper = {
    css: css`
        flex-grow: 1;
        & > div {
            width: 100%;
            max-width: unset;
        }
    `,
};

productActionsStyle.addToProductGroup = {
    css: css`
        ${xScreen("gt", "lg")} {
            margin-left: 24px;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

productActionsStyle.minQtyMessage = {
    size: 14,
    lineHeight: "22px",
    css: css`
        width: 100%;
    `,
};
